import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PrivateRoute = ({ requireAdmin = false }) => {
  const token = localStorage.getItem('access_token');

  if (!token) {
    toast.error('Debes iniciar sesión para acceder a esta página');
    return <Navigate to="/" replace />;
  }

  try {
    const decodedToken = jwt_decode(token);
    const currentTime = Math.floor(Date.now() / 1000);

    if (decodedToken.exp < currentTime) {
      toast.warning('Tu sesión ha expirado. Por favor inicia sesión nuevamente');
      localStorage.removeItem('access_token');
      return <Navigate to="/" replace />;
    }

    if (requireAdmin && !decodedToken.es_admin) {
      toast.error('Acceso restringido: Se requiere permisos de administrador');
      return <Navigate to="/index" replace />;
    }

    return <Outlet />;
  } catch (error) {
    toast.error('Error de autenticación. Por favor inicia sesión');
    localStorage.removeItem('access_token');
    return <Navigate to="/" replace />;
  }
};

export default PrivateRoute;